import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import "./_attendanceReport.scss";
import moment from 'moment';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import MonthlyAttendanceModal from './monthlyReportModal'
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const GET_ORGANISATION_PROFILE = gql`
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id) {
            id
            organisation_name
            logo
            complete_address
        }
    }
`;


class ReportTableData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            monthData: [],
            monthNum: 0,
            employeeValue: "",
            orgProfile: {},
            currentPage: 1,
            itemsPerPage: 10,
        }
    }

    componentDidMount() {
        this.loadOrgProfile();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.stateData?.getEmployeeeAttendanceReport !== this.props.stateData?.getEmployeeeAttendanceReport) {
            this.setState({ currentPage: 1 });
        }
    }

    getLogoDataUrl = async (logoFile) => {
        if (!logoFile) return "";
        const url = logoFile.startsWith("http")
            ? logoFile
            : `https://support.rizee.in/files/${logoFile}`;
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) return url;
            const blob = await res.blob();
            return await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = () => resolve(url);
                reader.readAsDataURL(blob);
            });
        } catch {
            return url;
        }
    };

    loadOrgProfile = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_ORGANISATION_PROFILE,
                variables: { institution_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            const data = result.data?.getOrganisationProfile;
            const profile = {
                organisation_name: data?.organisation_name || "",
                logo: data?.logo || "",
                complete_address: data?.complete_address || "",
            };
            this.setState({ orgProfile: profile });
            return profile;
        } catch (err) {
            console.error("loadOrgProfile error:", err);
            return this.state.orgProfile;
        }
    };

    openModal = (data, monthNum, empName, empType, stats) => {
        this.setState({
            modalShow: true,
            monthData: data,
            monthNum: monthNum,
            empName: empName,
            empType: empType,
            empStats: stats
        })
    }

    handleEmployeeChange = (event) => {
        this.setState({
            employeeValue: event.target.value,
            currentPage: 1
        })
    };

    renderPagination = (totalFiltered) => {
        const { currentPage, itemsPerPage } = this.state;
        const totalPages = Math.ceil(totalFiltered / itemsPerPage) || 1;
        const safePage = Math.min(currentPage, totalPages);
        const from = totalFiltered === 0 ? 0 : (safePage - 1) * itemsPerPage + 1;
        const to = Math.min(safePage * itemsPerPage, totalFiltered);

        const handlePageChange = (page) => {
            this.setState({ currentPage: page });
        };

        const handlePageSizeChange = (e) => {
            this.setState({ itemsPerPage: parseInt(e.target.value), currentPage: 1 });
        };

        const selectStyle = {
            border: "1.5px solid #cbd5e1",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "13px",
            color: "#0f172a",
            outline: "none",
            background: "#fff",
        };

        const btnStyle = (active) => ({
            padding: "6px 14px",
            borderRadius: "8px",
            border: "1px solid #cbd5e1",
            background: active ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : "#fff",
            color: active ? "#fff" : "#475569",
            fontWeight: "600",
            fontSize: "13px",
            cursor: "pointer",
            transition: "all 0.15s ease",
            outline: "none",
        });

        const navBtnStyle = (disabled) => ({
            padding: "6px 14px",
            borderRadius: "8px",
            border: "1px solid #cbd5e1",
            background: disabled ? "#f1f5f9" : "#fff",
            color: disabled ? "#94a3b8" : "#475569",
            fontWeight: "600",
            fontSize: "13px",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "all 0.15s ease",
            outline: "none",
        });

        const maxVisible = 5;
        let startPage = Math.max(1, safePage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);
        startPage = Math.max(1, endPage - maxVisible + 1);
        const pageNumbers = [];
        for (let p = startPage; p <= endPage; p++) pageNumbers.push(p);

        return (
            <Row className="mt-3 align-items-center">
                <Col xs={12} md={5} className="mb-2 mb-md-0 text-left">
                    <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                        <select style={selectStyle} value={itemsPerPage} onChange={handlePageSizeChange}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span style={{ fontSize: "13px", color: "#4b5563", fontWeight: "500" }}>
                            Showing {from} to {to} of {totalFiltered} Results
                        </span>
                    </div>
                </Col>
                <Col xs={12} md={7}>
                    <div className="d-flex justify-content-end align-items-center flex-wrap" style={{ gap: "8px" }}>
                        <button
                            type="button"
                            style={navBtnStyle(safePage <= 1)}
                            disabled={safePage <= 1}
                            onClick={() => handlePageChange(safePage - 1)}
                        >
                            Previous
                        </button>
                        {pageNumbers.map((p) => (
                            <button
                                key={p}
                                type="button"
                                style={btnStyle(p === safePage)}
                                onClick={() => handlePageChange(p)}
                            >
                                {p}
                            </button>
                        ))}
                        <button
                            type="button"
                            style={navBtnStyle(safePage >= totalPages)}
                            disabled={safePage >= totalPages}
                            onClick={() => handlePageChange(safePage + 1)}
                        >
                            Next
                        </button>
                    </div>
                </Col>
            </Row>
        );
    };


    getEmployeeAvatar = (name, type) => {
        const lowerName = name ? name.toLowerCase() : "";
        const lowerType = type ? type.toLowerCase() : "";

        if (lowerName.includes("chemistry")) {
            return { icon: "fal fa-flask", colorClass: "avatar-purple" };
        } else if (lowerName.includes("math")) {
            return { icon: "fal fa-calculator", colorClass: "avatar-blue" };
        } else if (lowerName.includes("botany") || lowerName.includes("biology")) {
            return { icon: "fal fa-leaf", colorClass: "avatar-green" };
        } else if (lowerName.includes("physics")) {
            return { icon: "fal fa-atom", colorClass: "avatar-pink" };
        } else if (lowerName.includes("warden") || lowerType.includes("warden")) {
            return { icon: "fal fa-shield", colorClass: "avatar-orange" };
        } else if (lowerName.includes("lecturer") || lowerType.includes("teacher") || lowerType.includes("lecturer")) {
            return { icon: "fal fa-chalkboard-teacher", colorClass: "avatar-teal" };
        } else {
            return { icon: "fal fa-user", colorClass: "avatar-indigo" };
        }
    };

    printReport = async () => {
        let EmployeeData = [];
        let keyword = this.state.employeeValue;
        if (keyword !== '') {
            EmployeeData = this.props.stateData.getEmployeeeAttendanceReport.length > 0 && this.props.stateData.getEmployeeeAttendanceReport.filter((item) => {
                return item.employee_name.toLowerCase().startsWith(keyword.toLowerCase());
            });
        } else {
            EmployeeData = this.props.stateData.getEmployeeeAttendanceReport;
        }

        if (!EmployeeData || !EmployeeData.length) return;

        let orgProfile = this.state.orgProfile || {};
        if (!orgProfile.logo) {
            orgProfile = (await this.loadOrgProfile()) || orgProfile;
        }

        const instituteName = Cookies.get("institutename") || "";
        const instituteShortName = instituteName
            ? instituteName
                .split(" ")
                .map((word) => word[0])
                .join("")
                .toUpperCase()
                .slice(0, 2)
            : "EA";

        const orgName = orgProfile.organisation_name || instituteName;
        const logoFile = orgProfile.logo || "";
        const orgAddress = orgProfile.complete_address || "";
        const logoSrc = logoFile ? await this.getLogoDataUrl(logoFile) : "";

        // Calculate statistics for the print layout
        const totalEmployees = EmployeeData.length;
        let sumTotalDays = 0;
        let sumPresentDays = 0;
        let sumAbsentDays = 0;
        let sumHalfDays = 0;

        EmployeeData.forEach(emp => {
            if (emp.employee_stats) {
                emp.employee_stats.forEach(stat => {
                    sumPresentDays += stat.present_days || 0;
                    sumAbsentDays += stat.absent_days || 0;
                    sumHalfDays += stat.half_days || 0;
                });
            }
        });

        sumTotalDays = sumPresentDays + sumAbsentDays + sumHalfDays;

        const printDate = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });

        // Build table headers HTML
        const months = this.props.stateData?.tableHeadMonths || [];
        const monthHeadersHtml = months.map(m => `<th colspan="3" style="text-align:center;">${m}</th>`).join("");
        const subHeadersHtml = months.map(m => `
            <th style="text-align:center;background:#f1f5f9;color:#475569;">P</th>
            <th style="text-align:center;background:#f1f5f9;color:#475569;">L</th>
            <th style="text-align:center;background:#f1f5f9;color:#475569;">H</th>
        `).join("");

        // Build table rows HTML
        const rowsHtml = EmployeeData.map((emp, i) => {
            const statsCellsHtml = emp.employee_stats.map(s => `
                <td style="text-align:center;font-weight:bold;color:#10b981;background:#f0fdf4;">${s.present_days}</td>
                <td style="text-align:center;font-weight:bold;color:#ef4444;background:#fef2f2;">${s.absent_days}</td>
                <td style="text-align:center;font-weight:bold;color:#f59e0b;background:#fffbeb;">${s.half_days}</td>
            `).join("");

            const branches = this.props.globals?.globalBranches || [];
            const matched = branches.find(b => parseInt(b.id) === parseInt(emp.branch_id));
            const branchName = matched ? matched.branch_name : "—";

            return `
                <tr>
                    <td style="text-align:center;color:#64748b;font-weight:bold;">${i + 1}</td>
                    <td style="text-align:left;font-weight:bold;color:#0f172a;">${emp.employee_name}</td>
                    <td style="text-align:left;color:#64748b;">${branchName}</td>
                    <td style="text-align:left;color:#64748b;">${emp.employee_role || "—"}</td>
                    ${statsCellsHtml}
                </tr>
            `;
        }).join("");

        const logoHtml = `
            <div style="display:flex;align-items:center;justify-content:center;gap:14px;margin-bottom:14px;">
                ${logoSrc ? `
                    <img src="${logoSrc}" alt="logo" style="width:60px;height:60px;object-fit:contain;flex-shrink:0;" />
                ` : `
                    <div style="width:56px;height:56px;background:linear-gradient(135deg,#6366f1,#4f46e5);border-radius:50%;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:900;font-size:22px;flex-shrink:0;">
                        ${instituteShortName}
                    </div>
                `}
                <div style="text-align:left;">
                    <div style="font-size:22px;font-weight:700;color:#111827;">${orgName}</div>
                    <div style="font-size:11px;color:#6b7280;margin-top:3px;">${orgAddress}</div>
                </div>
            </div>
        `;

        const printWindow = window.open("", "_blank");
        if (!printWindow) return;

        printWindow.document.write(`
            <html>
            <head>
                <title>Employee Attendance Report</title>
                <style>
                    body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 11px; padding: 20px; color: #1e293b; }
                    .header-center { text-align: center; padding-bottom: 14px; margin-bottom: 14px; border-bottom: 2.5px solid #6366f1; }
                    .sub-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0; }
                    .report-title { font-weight: 700; color: #6366f1; font-size: 14px; text-transform: uppercase; }
                    .report-date { color: #64748b; font-size: 11px; font-weight: 600; }
                    
                    /* Summary cards print layout */
                    .summary-cards-container { display: flex; gap: 15px; margin-bottom: 20px; }
                    .summary-card { flex: 1; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                    .summary-label { font-size: 9px; text-transform: uppercase; color: #64748b; font-weight: 700; margin-bottom: 4px; }
                    .summary-value { font-size: 18px; font-weight: 800; color: #0f172a; }
                    
                    /* Table styles */
                    table { border-collapse: collapse; width: 100%; margin-top: 10px; }
                    th, td { border: 1px solid #cbd5e1 !important; padding: 6px 8px; font-size: 10px; }
                    th { background-color: #f8fafc; color: #334155; font-weight: 700; text-transform: uppercase; }
                    
                    @media print {
                        @page { size: A4 landscape; margin: 6mm; }
                        body { padding: 0; margin: 0; }
                        table { page-break-inside: auto; }
                        tr { page-break-inside: avoid; page-break-after: auto; }
                        thead { display: table-header-group; }
                    }
                </style>
            </head>
            <body>
                <div class="header-center">
                    ${logoHtml}
                </div>
                <div class="sub-header">
                    <span class="report-title">Employee Attendance Report</span>
                    <span style="font-size: 11px; font-weight: 600; color: #475569; letter-spacing: 0.3px;">
                        P: Present &nbsp;|&nbsp; L: Leave &nbsp;|&nbsp; H: Half Day
                    </span>
                    <span class="report-date">Printed on: ${printDate}</span>
                </div>                
                <table>
                    <thead>
                        <tr>
                            <th rowspan="2" style="text-align:center;width:40px;">S.No.</th>
                            <th rowspan="2" style="text-align:left;">Employee</th>
                            <th rowspan="2" style="text-align:left;">Branch Name</th>
                            <th rowspan="2" style="text-align:left;">Role</th>
                            ${monthHeadersHtml}
                        </tr>
                        <tr>
                            ${subHeadersHtml}
                        </tr>
                    </thead>
                    <tbody>
                        ${rowsHtml}
                    </tbody>
                </table>
                
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() { window.close(); }, 500);
                    };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    render() {
        let keyword = this.state.employeeValue;

        let EmployeeData = [];

        if (keyword !== '') {
            EmployeeData = (this.props.stateData.getEmployeeeAttendanceReport || []).filter((item) => {
                return item.employee_name.toLowerCase().startsWith(keyword.toLowerCase());
            });
        } else {
            EmployeeData = this.props.stateData.getEmployeeeAttendanceReport || [];
        }

        const { currentPage, itemsPerPage } = this.state;
        const totalFiltered = EmployeeData.length;
        const totalPages = Math.ceil(totalFiltered / itemsPerPage) || 1;
        const safePage = Math.min(currentPage, totalPages);
        const startIndex = (safePage - 1) * itemsPerPage;
        const paginatedEmployees = EmployeeData.slice(startIndex, startIndex + itemsPerPage);

        return (
            <div className="table_data">

                <div className="ea-report-bar">
                    <input
                        className='ea-report-search'
                        type="search"
                        placeholder='Search by name'
                        value={this.state.employeeValue}
                        onChange={this.handleEmployeeChange}
                    />
                    <div className="ea-legends-container d-none d-md-flex">
                        <span className="ea-legend-title">Legends:</span>
                        <div className="ea-legend-item">
                            <span className="ea-legend-dot dot-p">
                                <i className="fas fa-check" />
                            </span>
                            <span>Present</span>
                        </div>
                        <div className="ea-legend-item">
                            <span className="ea-legend-dot dot-a">
                                <i className="fas fa-times" />
                            </span>
                            <span>Leave</span>
                        </div>
                        <div className="ea-legend-item">
                            <span className="ea-legend-dot dot-h">
                                <i className="fas fa-clock" />
                            </span>
                            <span>Half Day</span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                        <ReactHTMLTableToExcel
                            id="employee-attendance-report-xls-button"
                            className="ea-xls-btn text-uppercase"
                            table="employee-attendance-report-xls"
                            filename="Employee_Attendance_Report"
                            sheet="Attendance"
                            buttonText={
                                <>
                                    <i className="fas fa-file-excel me-2"></i>
                                    Excel
                                </>
                            }
                        />
                        <button
                            className="ea-xls-btn text-uppercase"
                            style={{ background: 'linear-gradient(135deg, #0d9488, #0f766e)', border: 'none' }}
                            onClick={() => this.printReport()}
                        >
                            <i className="fal fa-print" style={{ marginRight: '6px' }} />
                            Print
                        </button>
                    </div>
                </div>

                <div className="ea-table-wrapper">
                    <table className="ea-html-table">
                        <thead>
                            <tr>
                                <th rowSpan="2" className="sticky-col-sno">S.No.</th>
                                <th rowSpan="2" className="sticky-col-1">Employee</th>
                                <th rowSpan="2">Branch Name</th>
                                <th rowSpan="2">Role</th>
                                {
                                    this.props.stateData?.tableHeadMonths?.map((item) => {
                                        return (<th colSpan="1" key={item}>{item}</th>)
                                    })
                                }
                            </tr>
                            <tr>
                                {
                                    this.props.stateData?.tableHeadMonths?.map((item, idx) => {
                                        return (
                                            <th key={idx} className="ea-summary-header">
                                                <div className="d-flex align-items-center justify-content-center" style={{ gap: '6px' }}>
                                                    <span>Attendance Summary</span>
                                                    <i className="fal fa-info-circle text-muted" style={{ cursor: "pointer" }} />
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                paginatedEmployees.length > 0 ?
                                    (
                                        paginatedEmployees.map((item, empIdx) => {
                                            const avatar = this.getEmployeeAvatar(item.employee_name, item.employee_type);
                                            return (
                                                <tr key={empIdx}>
                                                    <td className="sticky-col-sno">{startIndex + empIdx + 1}</td>
                                                    <td className="emp-name sticky-col-1">
                                                        <div className="ea-emp-profile">
                                                            <span className={`ea-profile-avatar ${avatar.colorClass}`}>
                                                                <i className={avatar.icon} />
                                                            </span>
                                                            <span className="ea-emp-name-text">{item.employee_name}</span>
                                                        </div>
                                                    </td>
                                                    <td className="emp-branch">
                                                        {(() => {
                                                            const branches = this.props.globals?.globalBranches || [];
                                                            const matched = branches.find(b => parseInt(b.id) === parseInt(item.branch_id));
                                                            return matched ? matched.branch_name : "—";
                                                        })()}
                                                    </td>
                                                    <td className="emp-role">{item.employee_role || "—"}</td>
                                                    {
                                                        item.employee_stats.map((item2, statIdx) => {
                                                            return (
                                                                <td key={statIdx} className="month_view" onClick={() => this.openModal(item2.monthlyReport, item2.month_num, item.employee_name, item.employee_type, item2)}>
                                                                    <div className="ea-summary-container">
                                                                        <div className="ea-summary-pill ea-summary-p">
                                                                            <span className="ea-icon-wrapper p-icon">
                                                                                <i className="fas fa-check" />
                                                                            </span>
                                                                            <div className="ea-pill-details">
                                                                                <span className="ea-pill-label">Present</span>
                                                                                <span className="ea-pill-value">{item2.present_days}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ea-summary-pill ea-summary-a">
                                                                            <span className="ea-icon-wrapper a-icon">
                                                                                <i className="fas fa-times" />
                                                                            </span>
                                                                            <div className="ea-pill-details">
                                                                                <span className="ea-pill-label">Leave</span>
                                                                                <span className="ea-pill-value">{item2.absent_days}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="ea-summary-pill ea-summary-h">
                                                                            <span className="ea-icon-wrapper h-icon">
                                                                                <i className="fas fa-clock" />
                                                                            </span>
                                                                            <div className="ea-pill-details">
                                                                                <span className="ea-pill-label">Half Day</span>
                                                                                <span className="ea-pill-value">{item2.half_days}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                            )
                                        })
                                    )
                                    :
                                    (
                                        <tr>
                                            <td
                                                colSpan={4 + ((this.props.stateData?.tableHeadMonths?.length) || 0)}
                                                style={{ textAlign: "center", padding: "24px", color: "#94a3b8" }}
                                            >
                                                No matching employees
                                            </td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>
                </div>

                {this.renderPagination(totalFiltered)}

                <MonthlyAttendanceModal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    stateData={this.state}
                    year={this.props.stateData?.startDateCalender ? new Date(this.props.stateData.startDateCalender * 1000).getFullYear() : new Date().getFullYear()}
                />

                {/* Hidden table used to generate the Excel download */}
                <table id="employee-attendance-report-xls" style={{ display: "none" }}>
                    <thead>
                        <tr>
                            <th rowSpan="2">S.No.</th>
                            <th rowSpan="2">Employee</th>
                            <th rowSpan="2">Branch Name</th>
                            <th rowSpan="2">Role</th>
                            {this.props.stateData?.tableHeadMonths?.map((m) => (
                                <th colSpan="3">{m}</th>
                            ))}
                        </tr>
                        <tr>
                            {this.props.stateData?.tableHeadMonths?.map((m) => (
                                <>
                                    <th>Present</th>
                                    <th>Leave</th>
                                    <th>Half Day</th>
                                </>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(EmployeeData) && EmployeeData.length > 0
                            ? EmployeeData.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{item.employee_name}</td>
                                    <td>
                                        {(() => {
                                            const branches = this.props.globals?.globalBranches || [];
                                            const matched = branches.find(b => parseInt(b.id) === parseInt(item.branch_id));
                                            return matched ? matched.branch_name : "—";
                                        })()}
                                    </td>
                                    <td>{item.employee_role || "—"}</td>
                                    {item.employee_stats.map((s) => (
                                        <>
                                            <td>{s.present_days}</td>
                                            <td>{s.absent_days}</td>
                                            <td>{s.half_days}</td>
                                        </>
                                    ))}
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(withApollo(compose()(ReportTableData)));